import { render, staticRenderFns } from "./ToDoInbox.vue?vue&type=template&id=d1d52db2"
import script from "./ToDoInbox.vue?vue&type=script&lang=js"
export * from "./ToDoInbox.vue?vue&type=script&lang=js"
import style0 from "./ToDoInbox.vue?vue&type=style&index=0&id=d1d52db2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports